;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.processPushdown = (function () {
    const initialize = function () {
      $('.pushDownBtn').on('click', function (e) {
        const hiddenContent = $(this).find('.process-detail')
        e.preventDefault()

        $('.iconToggle', this).toggleClass('icon-updown icon-close')
        $('.iconToggle', this).toggleClass('processCarat processClose')

        if (hiddenContent.is(':visible')) {
          hiddenContent.slideUp('1000')
        } else {
          hiddenContent.slideDown('1000')
        }
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.processPushdown.initialize()
  })
}(jQuery, window))
